import cx from 'classnames'

export const focusRingStyles = ({
  hasError,
  variant = 'default',
}: {
  hasError: boolean
  /**
   * @defaultValue `'default'`
   */
  variant?: 'default' | 'pseudo' | 'focusWithin' | 'controlled'
}) =>
  cx(
    'transition-none', // Deliberate without animations to ensure zero delay when navigating quickly with the keyboard (e.g. inside a date picker)
    'outline-hidden focus-visible:ring-0 focus-visible:inset-ring-0', // Reset any default focus and shadow styles
    {
      default_noError:
        'focus-visible:inset-shadow-(--amaze-focus) dark:focus-visible:inset-shadow-(--amaze-focus-dark)',
      default_hasError:
        'focus-visible:inset-shadow-(--amaze-focus-error) dark:focus-visible:inset-shadow-(--amaze-focus-error-dark)',
      pseudo_noError:
        'focus-visible:before:inset-shadow-(--amaze-focus) dark:focus-visible:before:inset-shadow-(--amaze-focus-dark)',
      pseudo_hasError:
        'focus-visible:before:inset-shadow-(--amaze-focus-error) dark:focus-visible:before:inset-shadow-(--amaze-focus-error-dark)',
      focusWithin_noError:
        'focus-within:inset-shadow-(--amaze-focus) dark:focus-within:inset-shadow-(--amaze-focus-dark)',
      focusWithin_hasError:
        'focus-within:inset-shadow-(--amaze-focus-error) dark:focus-within:inset-shadow-(--amaze-focus-error-dark)',
      controlled_noError:
        'inset-shadow-(--amaze-focus) dark:inset-shadow-(--amaze-focus-dark)',
      controlled_hasError:
        'inset-shadow-(--amaze-focus-error) dark:inset-shadow-(--amaze-focus-error-dark)',
    }[`${variant}_${hasError ? 'hasError' : 'noError'}` as const],
  )
